import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import classNames from 'classnames';
import './button.scss';

type ButtonVariant = 'small';

type ButtonType = {
  text: string;
  link: string;
  variant?: ButtonVariant;
};

export const Button: React.FC<ButtonType> = ({ text, link, variant }) => (
  <Link
    to={link}
    className={classNames('button', { [`button--${variant}`]: variant })}
    data-text={text}
  >
    {text}
  </Link>
);
